<template>
    <form id="frm_action_matrix">
        <div class="text-box">
            <div class="mt-3">
                <label class="txt-right required">Mức độ rủi ro</label>
                <!-- <InputText
                    v-model="code"
                    class="input-text-box"
                    placeholder="Nhập"
                /> -->
                <Dropdown v-model="codeObj" :options="levelList" optionLabel="ordinal" placeholder="Chọn mức độ rủi ro"></Dropdown>
            </div>
            <input class="input_tmp_validator" id="code" />
            <div class="mt-3">
                <label class="txt-right required">Đặt tên cho mức độ rủi ro</label>
                <InputText
                    v-model="name"
                    class="input-text-box"
                    placeholder="Nhập"
                />
            </div>
            <input class="input_tmp_validator" id="name" />

            <div class="mt-3">
                <label class="txt-right required">Mô tả mức độ</label>
                <Textarea
                    v-model="description"
                    :autoResize="true"
                    rows="1"
                    maxlength="500"
                    class="input-text-box"
                    placeholder="Nhập"
                />
            </div>
            <input class="input_tmp_validator" id="description" />
            <div class="mt-3">
                <label class="txt-right required">Màu sắc</label>
                <div>
                    <Chrome v-model="color" />
                </div>
            </div>
            <input class="input_tmp_validator" id="color" />
            <div class="mt-3" v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button icon="pi pi-plus" class="btn-success" @click="addColor"/>
            </div>
        </div>
        <div class="mt-3">
            <DataTable :value="colorList" :key="loadDataTable">
                <template #empty>
                    <div class="txt-center">Chưa có dữ liệu</div>
                </template>
                <Column field="stt" header="STT" :headerStyle="{width: '7%'}">
                    <template #body="{index}">
                        {{ index+1 }}
                    </template>
                </Column>
                <Column field="color" header="Màu sắc" :headerStyle="{width: '15%'}">
                    <template #body="{data}">
                        <div class="color-box-render" :style="`background-color: ${data.color}`"></div>
                    </template>
                </Column>
                <Column field="code" header="Mức độ rủi ro" :headerStyle="{width: '15%'}"></Column>
                <Column field="name" header="Tên mức độ rủi ro" :headerStyle="{width: '30%'}"></Column>
                <Column field="description" header="Mô tả mức độ" :headerStyle="{width: '35%'}"></Column>
                <Column :headerStyle="{width: '13%'}">
                    <template #body="{data, index}" v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                        <Button type="button" class="p-button-edit mr-2" icon="pi pi-pencil" @click="editColor(data, index)"></Button>
                        <Button type="button" class="p-button-danger" icon="pi pi-trash" @click="removeColor(data, index)"></Button>
                    </template>
                </Column>
            </DataTable>
        </div>
        <div class="mt-3">
            <div class="mt-3 bold">Ma trận rủi ro</div>
            <span class="txt-msg">Vui lòng chọn vào từng ô trong ma trận để cấu hình mức độ rủi ro.</span>
        </div>
        <div class="matrix-box mt-3" v-if="dataMatrix.length == 2">
            <table id="matrix-table">
                <thead>
                    <tr>
                        <td colspan="2" rowspan="2">
                        </td>
                        <td class="vertical-th head-color" :colspan="dataMatrix[0]?.criteria_level ? dataMatrix[0]?.criteria_level.length : 0" rowspan="1">
                            {{ dataMatrix[0]?.name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="head-color" colspan="1" rowspan="1" v-for="item in dataMatrix[0]?.criteria_level" :key="item.id">
                            {{ parseInt(item.point) }}
                            <div>{{ item?.name }}</div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="head-color">
                        <td class="vertical-tb" :rowspan="dataMatrix[1]?.criteria_level ? dataMatrix[1]?.criteria_level.length + 1 : 1" colspan="1">
                            <span>{{ dataMatrix[1]?.name }}</span>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in risk_point" :key="index">
                        <td class="head-color" rowspan="1" colspan="1">
                            {{ parseInt(item.point) }}
                            <div>{{ item?.name }}</div>
                        </td>
                        <td @click="editPoints(j, index, ind)" :style="`background-color: ${j.color?.color}; color: ${j.color.color != 'transparent' && isHexTooDark(j.color.color) ? '#FFFFFF': '#000000'};`" class="body-color" rowspan="1" colspan="1" v-for="(j, ind) in item.risk" :key="ind">
                            {{ j.point }}
                            <div v-if="j.color?.name">
                                {{ j.color.name }}
                            </div>
                            <div v-else-if="j.color?.code">
                                {{ j.color.code }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <Dialog v-if="showRmColor" header="Xóa mức độ rủi ro" :visible.sync="showRmColor" :containerStyle="{width: '350px'}" :modal="true">
            <div class="confirmation-content">
                <span style="display: flex;">Bạn muốn xóa mức độ rủi ro <div :style="`border-radius: 2px; width: 15px; height: 15px; margin: 0 5px; background-color: ${objRmColor.obj.color}`"></div><b>{{ objRmColor.obj.name }}</b>?</span>
            </div>
            <template #footer v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button type="button" label="Huỷ" icon="pi pi-times" @click="showRmColor = false" class="btn-cancel"/>
                <Button type="button" label="Xác nhận" icon="pi pi-check" autofocus @click="acceptRmColor" class="main-style-button" />
            </template>
        </Dialog>
        <Dialog v-if="showEditColor" header="Sửa mức độ rủi ro" :visible.sync="showEditColor" class="popup_matrix" :containerStyle="{width: '600px'}" :modal="true">
            <div class="confirmation-content">
                <form id="frm_action_edit_color">
                    <div class="edit-color">
                        <div class="mt-3">
                            <label class="txt-right required">Mức độ rủi ro</label>
                            <!-- <InputText
                                v-model="objEditColor.obj.code"
                                class="input-text-box"
                                placeholder="Nhập"
                            /> -->
                            <Dropdown v-model="objEditColor.obj.codeObj" :options="levelList" optionLabel="ordinal" placeholder="Chọn mức độ rủi ro"></Dropdown>
                        </div>
                        <input class="input_tmp_validator" id="code_edit" />
                        <div class="mt-3">
                            <label class="txt-right required">Đặt tên cho mức độ rủi ro</label>
                            <InputText
                                v-model="objEditColor.obj.name"
                                class="input-text-box"
                                placeholder="Nhập"
                            />
                        </div>
                        <input class="input_tmp_validator" id="name_edit" />
                        <div class="mt-3">
                            <label class="txt-right required">Mô tả mức độ</label>
                            <Textarea
                                v-model="objEditColor.obj.description"
                                :autoResize="true"
                                rows="1"
                                maxlength="500"
                                class="input-text-box"
                                placeholder="Nhập"
                            />
                        </div>
                        <input class="input_tmp_validator" id="description_edit" />
                        <div class="mt-3">
                            <label class="txt-right required">Màu sắc</label>
                            <div>
                                <Chrome v-model="objEditColor.obj.color" :width="'100%'"/>
                            </div>
                        </div>
                        <input class="input_tmp_validator" id="color_edit" />
                    </div>
                </form>
            </div>
            <template #footer v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button type="button" label="Huỷ" icon="pi pi-times" @click="cancelEditColor" class="btn-cancel"/>
                <Button type="button" label="Xác nhận" icon="pi pi-check" autofocus @click="acceptEditColor" class="main-style-button"/>
            </template>
        </Dialog>
        <Dialog v-if="dataMatrix.length == 2" header="Mức độ rủi ro" :visible.sync="editPointPopup" class="popup_matrix" :containerStyle="{width: '600px'}" :modal="true">
            <div class="confirmation-content">
                <div>Tiêu chí: {{ dataMatrix[0].name }} - Mức độ: {{ dataEditPoint.a }}</div>
                <div>Tiêu chí: {{ dataMatrix[1].name }} - Mức độ: {{ dataEditPoint.b }}</div>
                <div>Rủi ro: {{ dataEditPoint.point }}</div>
                <label class="txt-right required">Chọn mức độ rủi ro</label>
                <form id="frm_action_choose_color">
                    <Dropdown v-model="chooseColor" :options="colorList" optionLabel="code" placeholder="Chọn mức độ rủi ro" :showClear="true" style="min-height: 46px;" class="d-flex align-items-center">
                        <template #value="slotProps">
                            <div class="country-item country-item-value d-flex align-items-center" v-if="slotProps.value">
                                <div class="color-box-render mr-3" :style="`background-color: ${slotProps.value.color}`"></div>
                                <div>{{ slotProps.value.name }}</div>
                            </div>
                            <span v-else>
                                {{slotProps.placeholder}}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <div class="country-item d-flex align-items-center">
                                <div class="color-box-render mr-3" :style="`background-color: ${slotProps.option.color}`"></div>
                                <div>{{ slotProps.option.name }}</div>
                            </div>
                        </template>
                    </Dropdown>
                    <input class="input_tmp_validator" id="choose_color" />
                </form>
            </div>
            <template #footer v-if="$store.getters.controllers?.formula && $store.getters.controllers?.formula.includes('edit')">
                <Button type="button" label="Huỷ" icon="pi pi-times" @click="cancelColor" class="btn-cancel"/>
                <Button type="button" label="Xác nhận" icon="pi pi-check" autofocus @click="acceptColor" class="main-style-button" />
            </template>
        </Dialog>
    </form>
</template>
  
<script>
import ApiRepository from "@/core/ApiRepository";
//   import moment from "moment-timezone";
// import ColourPicker from '@/components/ColourPicker'
import tinycolor from "tinycolor2";
import { Chrome } from 'vue-color'
export default {
    name: "pointComponent",
    components: {
        Chrome,
        // ColourPicker
    },
    props: {
      value: Array,
      company_id: String,
      listUid: Array,
      formula: String,
      dataColor: Array,
      show: Boolean
    },
    async created() {
        if (this.listUid && this.show) {
            if (this.$props.value.length > 0) {
                this.dataColor.map(color => {
                    color.ordinal = color?.level?.ordinal;
                    color.code = color?.level?.ordinal;
                    this.$props.value.map((m) => {
                        if (color.id == m.risk_color_id) {
                            this.valueData[`${m.criteria_level_id_col} + ${m.criteria_level_id_row}`] = color
                        }
                    })
                })
            }
            this.dataColor = this.dataColor.sort((a, b) => b.ordinal - a.ordinal);
            await this.loadCriteria();
        }
        await this.getListLevel();
    },
    watch: {
        "color"() {
            if (this.color?.hex8) {
                this.color = this.color.hex8;
            }
        },
        async "listUid"() {
            if (this.show && this.company_id) {
                await this.loadCriteria();
            }
        },
        async "show"() {
            if (this.listUid && this.company_id) {
                await this.loadCriteria();
            }
        },
    },
    data() {
      return {
        color: "#345da9",
        code: null,
        name: null,
        description: null,
        editPointPopup: false,
        valueData: [],
        dataMatrix: [],
        colorList: [],
        criterias: [],
        risk_point: [],
        dataEditPoint: {},
        indexEdit: [],
        chooseColor: null,
        objRmColor: {},
        showRmColor: false,
        showEditColor: false,
        objEditColor: {},
        levelList: [],
        codeObj: {},
        loadDataTable: 0
      };
    },
    
    methods: {
        isHexTooDark(hexColor) {
            // const rgb = this.hexToRgb(hexColor);
            // return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2] < 40;
            var c = tinycolor(hexColor);
            return c.isDark();
        },
        hexToRgb(hex) {
            let value = hex.replace('#', '');
            return value.length === 3 ? value.split('').map(c => parseInt(c.repeat(2), 16)) : value.match(/.{1,2}/g).map(v => parseInt(v, 16))
        },
        mapDataFormat() {
            if (!this.$commonFuction.isEmptyObject(this.risk_point)) {
                var risk_arr = [];
                this.risk_point.map(m => {
                    if (!this.$commonFuction.isEmptyObject(m.risk)) {
                        m.risk.map(n => {
                            var item = {
                                criteria_level_id_col: n.col_id,
                                criteria_level_id_row: m.id,
                                risk_color_id: n?.color ?? null,
                                point : n.point
                            }
                            risk_arr.push(item);
                        })
                    }
                })
                this.$emit("input", risk_arr);
            }
        },
        evil(fn) {
            return new Function('return ' + fn)();
        },
        async getListLevel() {
            if (this.$commonFuction.isEmpty(this.company_id)) {
                return;
            }
            var token = this.$store.getters.token ? this.$store.getters.token : null
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                await ApiRepository.post("/_api/formula/level_list", {company_id: this.company_id}, {headers}).then(async (res) => {
                    this.levelList = res.data.data.list;
                }).catch((err) => {
                    console.log(err);
                })
            }
        },
        async loadCriteria() {
            if (this.$commonFuction.isEmpty(this.company_id)) {
                return;
            }
            var token = this.$store.getters.token ? this.$store.getters.token : null
            if(token){
                const headers = {
                    "Authorization": "Bearer "+token,
                };
                await ApiRepository.post("/_api/criteria/list_by_ids", {list_ids: this.listUid, company_id: this.company_id}, {headers}).then(async (res) => {
                    this.dataMatrix = res.data.data;
                    if (this.dataMatrix.length > 0) {
                        this.risk_point = [];
                        this.dataMatrix[1].criteria_level.map(m => {
                            var item = {
                                id: m.id,
                                point: m.point,
                                name: m.name,
                                risk: []
                            }
                            this.dataMatrix[0].criteria_level.map(n => {
                                item.risk.push({
                                    id: n.id + this.formula.replaceAll(n.criteria_id, n.point).replaceAll(m.criteria_id, m.point),
                                    col_id: n.id,
                                    a: n.point,
                                    b: m.point,
                                    point: this.evil(this.formula.replaceAll(n.criteria_id, n.point).replaceAll(m.criteria_id, m.point)),
                                    color: this.valueData[`${n.id} + ${m.id}`] ?? {color: "transparent"}
                                })
                            })
                            this.risk_point.push(item);
                        })
                    }
                    this.colorList = this.dataColor;
                    this.colorList = this.colorList.sort((a, b) => b.ordinal - a.ordinal);
                    this.$emit("matrix_color", this.colorList);
                    this.$emit("matrix_rowcol", {criteria_id_row: this.dataMatrix[1]?.id, criteria_id_col: this.dataMatrix[0]?.id})
                    this.mapDataFormat();
                }).catch((err) => {
                    console.log(err);
                })
            }
        },
        async validateData() {
            this.validationErrors = {};
            let code_add = document.getElementById("code");
            if (
                this.$commonFuction.isEmptyObject(this.codeObj)
            ) {
                code_add.setCustomValidity("Mức độ rủi ro không được để trống!");
            } else {
                if (this.codeObj.name.length > 255) {
                    code_add.setCustomValidity("Mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    code_add.setCustomValidity("");
                }
            }

            let name_add = document.getElementById("name");
            if (
                this.$commonFuction.isEmptyObject(this.name)
            ) {
                name_add.setCustomValidity("Tên mức độ rủi ro không được để trống!");
            } else {
                if (this.codeObj.name.length > 255) {
                    name_add.setCustomValidity("Tên mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    name_add.setCustomValidity("");
                }
            }

            let description_add = document.getElementById("description");
            if (
                this.$commonFuction.isEmpty(this.description)
            ) {
                description_add.setCustomValidity("Mô tả mức độ không được để trống!");
            } else {
                if (this.description.length > 500) {
                    description_add.setCustomValidity("Mô tả mức độ nhập tối đa 500 ký tự!");
                } else {
                    description_add.setCustomValidity("");
                }
            }

            let color_add = document.getElementById("color");
            if (
                this.$commonFuction.isEmpty(this.color)
            ) {
                color_add.setCustomValidity("Màu sắc không được để trống!");
            } else {
                color_add.setCustomValidity("");
            }

            var inpObj = document.getElementById("frm_action_matrix");
            if (!inpObj.checkValidity()) {
                inpObj.reportValidity();
                return true;
            }
        },
        resetData() {
            this.color = "#345da9";
            this.code = null;
            this.codeObj = {};
            this.name = null;
            this.description = null;
        },
        
        async validateDataColor() {
            this.validationErrors = {};
            let choose_color_add = document.getElementById("choose_color");
            if (
                this.$commonFuction.isEmpty(this.chooseColor) ||
                this.$commonFuction.isEmptyObject(this.chooseColor)
            ) {
                choose_color_add.setCustomValidity("Mức độ rủi ro không được để trống!");
            } else {
                choose_color_add.setCustomValidity("");
            }

            var inpObj = document.getElementById("frm_action_choose_color");
            if (!inpObj.checkValidity()) {
                inpObj.reportValidity();
                return true;
            }
        },
        editPoints(obj, i_a, i_b) {
            this.editPointPopup = true;
            this.dataEditPoint = obj;
            this.chooseColor = obj?.color?.id ? obj?.color : null;
            this.indexEdit = [i_a, i_b];
        },
        async acceptColor() {
            if (await this.validateDataColor()) {
                return;
            }
            this.editPointPopup = false;
            this.risk_point[this.indexEdit[0]].risk[this.indexEdit[1]].color = this.chooseColor;
            this.indexEdit = [];
            this.dataEditPoint = {};
            this.chooseColor = null;
            this.mapDataFormat();
        },
        cancelColor() {
            this.editPointPopup = false;
            this.indexEdit = [];
            this.dataEditPoint = {};
            this.chooseColor = null;
        },
        async addColor() {
            this.$commonFuction.is_loading(true);
            if (await this.validateData()) {
                this.$commonFuction.is_loading(false);
                return;
            }
            if (Object.entries(this.validationErrors).length !== 0) {
                this.$commonFuction.is_loading(false);
            }
            console.log(this.codeObj);
            var params = {
                id: `color-${this.$commonFuction.generateUUID()}`,
                color: this.color,
                name: this.name,
                code: this.codeObj?.ordinal,
                level: this.codeObj,
                description: this.description,
                company_id: this.company_id,
                level_id: this.codeObj?.id,
                ordinal: this.codeObj?.ordinal,
            };
            this.colorList.push(params);
            this.colorList = this.colorList.sort((a, b) => b.ordinal - a.ordinal);
            this.resetData();
            this.$commonFuction.is_loading(false);
            console.log("this.colorList", this.colorList);
            this.$emit("matrix_color", this.colorList);
        },
        async removeColor(obj, index) {
            this.objRmColor = {
                obj: obj,
                index: index
            }
            this.showRmColor = true;
            this.$emit("matrix_color", this.colorList);
        },
        async validateEditColor() {
            this.validationErrors = {};
            let code_add = document.getElementById("code_edit");
            if (
                this.$commonFuction.isEmptyObject(this.objEditColor.obj.codeObj)
            ) {
                code_add.setCustomValidity("Mức độ rủi ro không được để trống!");
            } else {
                if (this.objEditColor.obj.codeObj.name.length > 255) {
                    code_add.setCustomValidity("Mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    code_add.setCustomValidity("");
                }
            }

            let name_add = document.getElementById("name_edit");
            if (
                this.$commonFuction.isEmptyObject(this.objEditColor.obj.name)
            ) {
                name_add.setCustomValidity("Tên mức độ rủi ro không được để trống!");
            } else {
                if (this.objEditColor.obj.name.length > 255) {
                    name_add.setCustomValidity("Tên mức độ rủi ro nhập tối đa 255 ký tự!");
                } else {
                    name_add.setCustomValidity("");
                }
            }

            let description_add = document.getElementById("description_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditColor.obj.description)
            ) {
                description_add.setCustomValidity("Mô tả mức độ không được để trống!");
            } else {
                if (this.objEditColor.obj.description.length > 500) {
                    description_add.setCustomValidity("Mô tả mức độ nhập tối đa 500 ký tự!");
                } else {
                    description_add.setCustomValidity("");
                }
            }

            let color_add = document.getElementById("color_edit");
            if (
                this.$commonFuction.isEmpty(this.objEditColor.obj.color)
            ) {
                color_add.setCustomValidity("Màu sắc không được để trống!");
            } else {
                color_add.setCustomValidity("");
            }

            var inpObj = document.getElementById("frm_action_edit_color");
            if (!inpObj.checkValidity()) {
                inpObj.reportValidity();
                return true;
            }
        },
        async acceptRmColor() {
            this.colorList.splice(this.objRmColor.index,1);
            this.risk_point.map(m => {
                m.risk.map(n => {
                    if (n?.color?.id == this.objRmColor.obj?.id) {
                        this.$set(n, 'color', {color: "transparent"});
                        this.mapDataFormat();
                    }
                })
            })
            this.objRmColor = {};
            this.showRmColor = false;
            this.$emit("matrix_color", this.colorList);
        },
        async cancelEditColor() {
            this.objEditColor = {};
            this.showEditColor = false;
        },
        async acceptEditColor() {
            if (await this.validateEditColor()) {
                return;
            }
            this.objEditColor.obj.color = this.objEditColor.obj.color?.hex8 ?? (this.objEditColor.obj.color?.hex ?? this.objEditColor.obj.color);
            this.colorList[this.objEditColor.index] = this.objEditColor.obj;
            this.colorList[this.objEditColor.index].code = this.objEditColor.obj?.codeObj?.ordinal;
            this.colorList[this.objEditColor.index].level_id = this.objEditColor.obj?.codeObj?.id;
            this.colorList[this.objEditColor.index].ordinal = this.objEditColor.obj?.codeObj?.ordinal;
            this.risk_point.map(m => {
                m.risk.map(n => {
                    if (n?.color?.id) {
                        if (n.color.id == this.objEditColor.obj.id) {
                            this.$set(n, 'color', this.objEditColor.obj);
                        }
                    }
                })
            })
            this.objEditColor = {};
            this.colorList = this.colorList.sort((a, b) => b.ordinal - a.ordinal);
            this.showEditColor = false;
            this.mapDataFormat();
        },
        async editColor(obj, index) {
            var obj_tmp = Object.assign({}, obj);
            obj_tmp.codeObj = {
                id: obj_tmp.level_id.toString(),
                name: obj_tmp.level.name,
                ordinal: obj_tmp.ordinal
            }
            console.log(obj_tmp);
            this.objEditColor = {
                obj: obj_tmp,
                index: index
            }
            this.showEditColor = true;
        }
    },
};
</script>

<style lang="scss">
    label {
        font-weight: bold;
    }
    .button-clear {
        position: absolute;
        background-color: red;
        border-radius: 50%;
        right: 0;
        top: 0;
        width: 20px;
        height: 20px;
        padding: 0;
        display: flex;
        cursor: pointer;
    }
    .item-img {
        width: 80px;
        height: 80px;
        position: relative;
        padding: 0;
    }
    .p-password .pi.pi-eye {
        color: #000;
        font-size: 20px;
    }
    .p-checkbox, .p-radiobutton.p-component{
        margin-right: 1rem !important;
    }
    .txt-last-update {
        color: #666666;
        font-size: calc(16px*0.8);
    }
    .txt-msg {
        color: #B4B4B4;
    }
    .ml-4-5{
        margin-left: 2.5rem !important;
    }
    #matrix-table {
        td {
            width: 100px;
            height: 100px;
            border: 1px solid #000000;
            text-align: center;
            color: #000;
        }
    }
    .vertical-tb {
        -moz-transform: rotate(-180deg);  /* FF3.5+ */
        -o-transform: rotate(-180deg);  /* Opera 10.5 */
        -webkit-transform: rotate(-180deg);  /* Saf3.1+, Chrome */
        margin-left: -10em;
        margin-right: -10em;
        width: 50px !important;
        writing-mode: vertical-rl;
        span {
            display: flex;
            writing-mode: tb-rl;
            -webkit-writing-mode: vertical-rl;
            writing-mode: vertical-rl;
            width: 100%;
            align-items: center;
            justify-content: center;
        }
    }
    .vertical-th {
        height: 50px !important;
        white-space: nowrap;
    }
    .head-color {
        font-weight: bold;
        background-color: #F3F4F7;
    }
    .body-color {
        cursor: pointer;
        font-weight: bolder;
    }
    .vc-chrome,
    .vc-compact,
    .vc-sketch {
        /* position: absolute !important; */
        position: relative !important;
        /*bottom: 44px;*/
        top: 0;
        z-index: 100;
    }
    .color-box-render {
        width: 38px;
        height: 32px;
        border-radius: 5px;
        border: none;
    }
    .popup_matrix {
        width: 600px;
        .p-dialog-content{
            min-height: 200px;
        }
    }
    .edit-color .vc-chrome{
        width: 100% !important;
    }
    #frm_action_choose_color{
        position: absolute;
        width: 90%;
    }
    .btn-cancel{
        background-color: #F2F3F7;
        border: unset;
        color: #333333;
        .p-button-label{
        color: #333333 !important;
        }
        text-transform: none;
        font-size: 1rem;
        // font-family: 'adobe clean', sans-serif;
        border-radius: 3px;
        padding-left: 16px;
        padding-right: 16px;
        width: auto;
        margin-top: 0 !important;
        height: 40px;
        letter-spacing: 0;
        &:hover{
        color: #333333;
        background-color: #F2F3F7;
        }
    }
</style>
